module.exports = __webpack_public_path__ + "static/media/pc_icon_qr_code_normal.a2b38c52.svg";